import React, {useEffect} from 'react';
export const useScrollTo = ({
    subtractContainer,
    mouseDown, scrollRef, isCurrent, ref, expanded, topOffset=180, skipBottom=false}) => {
    useEffect(() => {
        if (mouseDown && mouseDown.current) {
            return;
        }
        if (isCurrent && scrollRef && scrollRef.current && ref.current) {
            // check if this element is not in scroll view. If its not
            // then scroll to it!
            
            let scrollTop = scrollRef.current.scrollTop;
            let height = scrollRef.current.offsetHeight;
            let top  = ref.current.offsetTop + 80;
            if (subtractContainer) {
                top -= scrollRef.current.getBoundingClientRect().top;
            }
            let elemHeight = ref.current.offsetHeight;
            let elemBottom = elemHeight > height ? top + (height - 150) : top + elemHeight;
            if (top < scrollTop + topOffset ) {
                scrollRef.current.scrollTop -= scrollTop + topOffset - top;
            } else if (!skipBottom && elemBottom > scrollTop + height) {
                scrollRef.current.scrollTop += (elemBottom - (scrollTop + height));
            }
        }
    }, [isCurrent, expanded]);
};
